import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.widget.DOC}
  query MosaicWidget(
    $tenantId: ID!
    $zoneId: ID!
    $widgetIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          widget(identifier: $widgetIdentifier) {
            ...FragmentMosaicWidget
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicWidgetQuery,
  ents.core.mosaic.Widget | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'mosaicDev',
      graphql.transformers.OUT.select('widget', fragments.widget.TRANSFORMER),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicWidgetQuery,
  ents.core.mosaic.Widget | undefined,
  graphql.schema.MosaicWidgetQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
